module.exports = __webpack_public_path__ + "static/img/5_po.986f657.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/index/5_po.jpg
// module id = 48
// module chunks = 0